import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/AccountPage.module.scss"
import {useTranslation} from "react-i18next";
import RoundTIckIcon from "@/svg/RoundTIckIcon.tsx";
import clsx from "clsx";
import ChevroneIcon from "@/svg/ChevronIocn.tsx";
import React, {ReactNode} from "react";
import SetPwd from "@/pages/account/elems/SetPwd.tsx";
import GenInfo from "@/pages/account/elems/GenInfo.tsx";
// import PromoSettings from "@/components/PromoSettings.tsx";
// import CMS from "@/utils/cms.ts";
// import {LocalLanguage} from "@/types_and_interfaces/types.ts";
// import useCommon from "@/hooks/common.ts";
// import EmailIcon from "@/svg/EmailIcon.tsx";
// import PhoneIcon from "@/svg/PhoneIcon.tsx";
import {useNavigate} from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";
// import SocialLinks from "@/ui/SocialLinks.tsx";
// import DividerSimple from "@/ui/DividerSimple.tsx";
import {useAtom} from "jotai/index";
import {profile} from "@/atoms/profile.ts";
import StatusMessage from "@/ui/StatusMessage.tsx";
import EditProfile from "@/pages/account/elems/EditProfile.tsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";

const AccountPage = () => {
    
    const {t} = useTranslation()
    const [user] = useAtom(profile)
    const verified:boolean = user?.kyc_general_status === "ProcessingSuccess" || user?.auth_type === "ByMPass"
    const navigate = useNavigate()
    const is_phone = Boolean(typeof user?.phone === "string" && user.phone.length)
    
    
    const nav_to_kyc = () => {
        if(!user?.permissions.is_kyc_allowed) {
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "info", t("can_not_go_to_kyc"))
            return
        }
        navigate(DashboardClass.dashboard_routes.KYC)
    }
    
    return (
        <DashboardGenComponent
            header_type={"dark"}
            responsive1
            
            header_content={
                <div className={st.h}>
                    
                    <h4 className={st.heading}>
                        {t("settings")}
                    </h4>
                    
                    <div className={clsx(st.header_content, !verified && st.unverified)}>
                        
                        <div className={st.left}>
                            <span>{t("acc_status")}</span>
                        </div>
                        
                        {/*TODO : propper conditions*/}
                        
                        
                        {verified ? (
                            <div className={st.right}>
                                <RoundTIckIcon/>
                                
                                {t("verified")}
                            </div>
                        ) : (
                            <>
                                {(user?.kyc_general_status === "Unknown") && (
                                    <button
                                        onClick={nav_to_kyc}
                                    >
                                        {t("finish_registration")}
                                        <ChevroneIcon/>
                                    </button>
                                )}
                                
                                {user?.kyc_general_status === "UserStarted" && (
                                    <button
                                        onClick={nav_to_kyc}
                                    >
                                        {t("finish_registration")}
                                        <ChevroneIcon/>
                                    </button>
                                )}
                                
                                {(user?.kyc_general_status === "ProcessingFailed" || user?.kyc_general_status === "ProcessingFailedAndSentToManager") && (
                                    <div className={st.status}>
                                        <span>
                                            {t("unverified")}
                                        </span>
                                    </div>
                                )}
                                
                                {(user?.kyc_general_status === "UserFinished" || user?.kyc_general_status === "ServerProcessing") && (
                                    <div className={st.status}>
                                        <span>
                                            {t("processing")}
                                        </span>
                                    </div>
                                )}
                            
                            </>
                        )}
                    
                    </div>
                
                </div>
            }
            
            column_center={
                <div className={st.column_center}>
                    
                    {user?.kyc_general_status === "ProcessingFailedAndSentToManager" && (
                        
                        <StatusMessage
                            is_phone={is_phone}
                            status={"danger"}
                            text={t("failed_kyc1")}
                        />
                        
                    )}
                    
                    {user?.kyc_general_status === "ProcessingFailed" && (
                        
                        <StatusMessage
                            is_phone={true}
                            status={"warning"}
                            text={t("failed_kyc")}
                            continue_kyc
                        />
                        
                    )}
                    
                    {/*{user?.permissions.is_pass_code_modifiable && (*/}
                        <ColumnItemContainer
                            title={t("security")}
                        >
                            <SetPwd/>
                        </ColumnItemContainer>
                    {/*)}*/}
                    
                    <ColumnItemContainer
                        title={t("gen_info")}
                    >
                        <GenInfo/>
                    </ColumnItemContainer>
                    
                    {/*{enable_profile_edit && (*/}
                        <ColumnItemContainer
                            title={t("complete_profile")}
                        >
                            <EditProfile/>
                        </ColumnItemContainer>
                    {/*)}*/}
                    
                    {/*<ColumnItemContainer*/}
                    {/*    title={t("promo_materials")}*/}
                    {/*>*/}
                    {/*    <PromoSettings />*/}
                    {/*</ColumnItemContainer>*/}
                    
                    {/*<ColumnItemContainer*/}
                    {/*    title={t("contacts")}*/}
                    {/*    className={st.contact_block}*/}
                    {/*>*/}
                    {/*    <ContactCard mobile />*/}
                    {/*</ColumnItemContainer>*/}
                    
                </div>
            }
            
            // column_right={
            //     <ContactCard />
            // }
        />
    )
}

interface ColumnProps {
    title: string
    children: ReactNode
    className?:string
}

const ColumnItemContainer:React.FC<ColumnProps> = ({children, title, className}) => {
    
    return (
        <div className={clsx(st.column_item, className)}>
            <strong>
                {title}
            </strong>
            
            <div className={st.children}>
                {children}
            </div>
        </div>
    )
}

// interface ContactCardButton  {
//     value?: string
//     key_id: string
//     onClick?():void
//     icon?: ReactNode
//     social_links?:boolean
// }

// interface ContactCardProps {
//     mobile?: boolean
// }
//
// const ContactCard:React.FC<ContactCardProps> = ({mobile}) => {
//    
//     const {t, i18n} = useTranslation()
//     const raw_data = CMS.general_info
//     const data = CMS.langAwareFilter(raw_data, (i18n.language as LocalLanguage))
//     const {phone_number, contact_email} = data
//     const common_hook = useCommon()
//     const navigate = useNavigate()
//    
//     const contact_menu_arr:Array<ContactCardButton> = [
//         {
//             value: phone_number ? phone_number : "",
//             key_id: "phone_number",
//             onClick: () => {
//                 common_hook.handleTelTo(phone_number)
//             },
//             icon: <PhoneIcon />
//         },
//         {
//             value: contact_email && contact_email,
//             key_id: "contact_email",
//             onClick: () => {
//                 common_hook.handleEmailTo(contact_email)
//             },
//             icon: <EmailIcon />
//         },
//         {
//             value: t("offices"),
//             key_id: "offices",
//             onClick: () => {
//                 navigate(DashboardClass.dashboard_routes.Locations)
//             },
//             icon: <ChevroneIcon />
//         },
//         {
//             key_id: "social_links",
//             social_links: true
//         },
//         // {
//         //     value: t("delete_account"),
//         //     key_id: "delete_account",
//         //     onClick: () => {
//         //         alert("O figa tie! Esti cu noi pe toata viata! HAAAAHAHAHAHA!")
//         //     },
//         //     icon: <CloseIcon />
//         // },
//     ]
//    
//     return (
//         <div className={clsx(st.column_right, mobile && st.mobile)}>
//            
//             {contact_menu_arr.map((item:ContactCardButton, i:number) => {
//                
//                 const {key_id, icon, value, social_links, onClick} = item
//                
//                 return (
//                     <React.Fragment key={`key_${key_id}_item`}>
//                        
//                         {social_links ? (
//                             <SocialLinks for_light_bg/>
//                         ) : (
//                             <div
//                                 onClick={onClick}
//                                 className={clsx(st[key_id], st.contact_btn_item)}
//                             >
//                                 <span>
//                                     {value}
//                                 </span>
//                                
//                                 {icon}
//                             </div>
//                         )}
//                        
//                         {i !== contact_menu_arr.length - 1 && <DividerSimple />}
//                     </React.Fragment>
//                 )
//                
//             })}
//            
//
//         </div>
//     )
// }

export default AccountPage